<template>
  <div class="flex items-center cursor-pointer gap-2 w-full">
    <EngagementTooltip
      :show-tooltip="showSentTooltip"
      :is-active="true"
      :timestamps="sentTimestamps"
      :title="'Sent at'"
      :type="engagementTooltipTypes.SENT"
      :count="0"
      :show-count="false"
      source="linkedin_engagement"
    />

    <EngagementTooltip
      v-if="isInvite"
      :show-tooltip="showAcceptedTooltip"
      :is-active="isAccepted"
      :timestamps="acceptedTimestamps"
      :title="'Accepted at'"
      :type="engagementTooltipTypes.ACCEPTED"
      :count="isAccepted ? 1 : 0"
      :show-count="false"
      :original-count="isAccepted ? 1 : 0"
      source="linkedin_engagement"
    />

    <EngagementTooltip
      v-else
      :show-tooltip="showRepliedTooltip"
      :is-active="isReplied"
      :timestamps="repliedTimestamps"
      :title="'Replied at'"
      :type="engagementTooltipTypes.REPLIED"
      :count="replyCount"
      :show-count="true"
      :original-count="replyCount"
      source="linkedin_engagement"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { engagementTooltipTypes } from "@/src/constants/emailConstants.js";
import EngagementTooltip from "@/src/components/emails/renderers/EngagementTooltip.vue";

const props = defineProps({
  value: {
    type: Object,
    required: true,
  },
  row: {
    type: Object,
    default: () => ({}),
  },
});

const engagement = props.value || {};
const activityType = props.row?.activity_type;
const isInvite = activityType === "INVITE";

const isAccepted = engagement.status === "ACCEPTED";
const isReplied = engagement.status === "REPLIED";

const replyCount = computed(() => engagement.reply_count || 0);

const sentTimestamps = computed(() =>
  engagement.sent_timestamp ? [engagement.sent_timestamp] : [],
);

const acceptedTimestamps = computed(() =>
  engagement.accepted_timestamp ? [engagement.accepted_timestamp] : [],
);

const repliedTimestamps = computed(() => 
  engagement.replied_created_at || []
);

const showSentTooltip = computed(() => sentTimestamps.value.length > 0);
const showAcceptedTooltip = computed(() => acceptedTimestamps.value.length > 0);
const showRepliedTooltip = computed(() => repliedTimestamps.value.length > 0);
</script>
